import { Link } from 'react-router'
import { useCopy, useLocale } from '../../content'
import { pathFor } from '../../routes'

/**
 * Home / current page, on the photo of a service hero (the page's
 * BreadcrumbList JSON-LD carries the same two steps). White at 85 %: the
 * kicker text is 17 px regular, below the large-text threshold, and 85 % is
 * the lowest alpha that clears 4.5:1 over the hero veil even where the photo
 * underneath is pure white.
 */
export function Breadcrumbs({ current }: { current: string }) {
  const copy = useCopy()
  const locale = useLocale()
  return (
    <nav aria-label={copy.a11y.breadcrumbs} className="vc2-kicker text-white/85">
      <ol className="flex flex-wrap gap-2">
        <li>
          <Link to={pathFor('home', locale)} className="underline-offset-4 hover:underline">
            {copy.nav.home}
          </Link>
        </li>
        <li aria-hidden="true">/</li>
        <li aria-current="page">{current}</li>
      </ol>
    </nav>
  )
}
